export default "__VITE_ASSET__6e3c3262__"